import CommandIdEnum from "../enums/CommandIdEnums";
import CommandStack from "../logic/CommandStack";
import i18n from "../localization/i18n";
import { useCurrentCommandState } from "../store/currentCommandStateStore";

export default class Command {
    id: CommandIdEnum;
    #commandStack: CommandStack;
    protected commandNameResourceKey: string = "";
    protected initialPrompResourceKey: string = "";
    protected showCommandInfo: boolean = true;
    #stacked: boolean = true;
    #onEnd: (() => void) | undefined;

    constructor(id: CommandIdEnum, commandStack: CommandStack) {
        this.id = id;
        this.#commandStack = commandStack;
    }
    
    getId() { return this.id; }

    getName() { return i18n.t(this.commandNameResourceKey); }

    getNameResourceKey() { 
        return this.commandNameResourceKey;
    };

    getInitialPromptResourceKey() {
        return this.initialPrompResourceKey;
    }

    getShowCommandInfo() {
        return this.showCommandInfo;
    }

    canLaunch(_commandId: CommandIdEnum): boolean {
        return false;
    }

    start() {
        console.log(`Starting command: ${i18n.t(this.commandNameResourceKey)}`);
    }

    end() {
        console.log(`Ending command: ${i18n.t(this.commandNameResourceKey)}`);

        // Cleared before firing: end() is re-entrant (cancel() -> end(), the running-command X
        // button -> end()), and an owner handling this callback typically ends itself, which can
        // come straight back through here.
        const onEnd = this.#onEnd;
        this.#onEnd = undefined;
        onEnd?.();
    }

    activate() {}

    deactivate() {}

    // A command run as one step of another command's interaction - the move that positions a fresh
    // clone, for instance - does not get its own stack entry. The owning command is the one the
    // user launched, the one the running-command bar names, and the one a future undo would step
    // back through; the sub-command is an implementation detail of it.
    setStacked(stacked: boolean) {
        this.#stacked = stacked;
    }

    isStacked(): boolean {
        return this.#stacked;
    }

    // Called once when this command finishes, however it finished, so a command that started it as
    // a sub-command can finish up in turn.
    setOnEnd(callback: (() => void) | undefined) {
        this.#onEnd = callback;
    }

    addToStack() {
        if (this.#stacked)
            this.#commandStack.addToStack(this);
    }

    removeFromStack() {
        if (this.#stacked)
            this.#commandStack.removeFromStack(this);
    }

    protected getCommandStack(): CommandStack {
        return this.#commandStack;
    }

    // By default, commands will be stopped when viewer mode changes. 
    // Override this method in commands that should not be stopped on viewer mode change
    onViewerModeChange() {
        this.end();
    }

}